module.exports = __webpack_public_path__ + "media/domenj/bghead-12fcafa5.png";